"use strict";

import "core-js/modules/es6.number.constructor";
import moment from "moment";

/**
 * [filterDay 短时间月-日 小时：分]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function filterDay(value) {
  if (moment(parseInt(value) * 1000).isValid() && parseInt(value) !== 0) {
    if (value.length === 13) {
      return moment(parseInt(value)).format("MM-DD HH:mm");
    } else {
      return moment(parseInt(value) * 1000).format("MM-DD HH:mm");
    }
  } else {
    return "--";
  }
}
/**
 * [filterTime 完成时间：年-月-日 小时：分]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function filterTime(value) {
  if (moment(parseInt(value) * 1000).isValid() && parseInt(value) !== 0) {
    if (value.length === 13) {
      return moment(parseInt(value)).format("YYYY-MM-DD HH:mm");
    } else {
      return moment(parseInt(value) * 1000).format("YYYY-MM-DD HH:mm");
    }
  } else {
    return "--";
  }
}
/**
 * [fullTime 完成时间：年-月-日 小时：分：秒]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function filterFullTime(value) {
  if (moment(parseInt(value) * 1000).isValid() && parseInt(value) !== 0) {
    if (value.length === 13) {
      return moment(parseInt(value)).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment(parseInt(value) * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  } else {
    return "--";
  }
}
/**
 * [fullDay 完成时间：年-月-日]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function filterFullDay(value) {
  if (moment(parseInt(value) * 1000).isValid() && parseInt(value) !== 0) {
    if (value.length === 13) {
      return moment(parseInt(value)).format("YYYY-MM-DD");
    } else {
      return moment(parseInt(value) * 1000).format("YYYY-MM-DD");
    }
  } else {
    return "--";
  }
}

/**
 * [emptyStr 空字符串]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
export function filterEmptyStr(str) {
  if (str !== "" && str !== null && str !== undefined) {
    return str;
  } else {
    return "--";
  }
}

/**
 * [encryptMobile 屏蔽手机号码中间4位]
 * @param  {[type]} mobile [description]
 * @return {[type]}        [description]
 */
export function filterEncryptMobile(mobile) {
  if (mobile !== "") {
    return mobile.substr(0, 3) + "****" + mobile.substr(7);
  } else {
    return "--";
  }
}

/**
 * [filterWhether 是否判断: 1 是，0 否]
 * @param  {[type]} val [description]
 * @return {[type]}     [description]
 */
export function filterWhether(val) {
  switch (parseInt(val)) {
    case 1:
      return "是";
    case 0:
      return "否";
    default:
      return "--";
  }
}
/**
 * [filterSex 性别1 男， 2 女]
 * @param  {[type]} val [description]
 * @return {[type]}     [description]
 */
export function filterSex(val) {
  switch (parseInt(val)) {
    case 1:
      return "男";
    case 2:
      return "女";
    default:
      return "--";
  }
}

/**
 * [filterMoney 格式化金钱]
 * @param  {[type]} val [description]
 * @return {[type]}     [description]
 */
export function filterMoney(val) {
  if (val !== "") {
    return Number(val / 100).toFixed(2);
  } else {
    return "0.00";
  }
}
/**
 * [filterBr 格式化换行符]
 * @param {[type]} val
 */
export function filterBr(val) {
  if (val) {
    return val.replaceAll("/n;", "<br />");
  }
}
export function isMoney(val) {
  var exp = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/;
  return exp.test(val);
}